// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".resident-group-list[data-v-24827c22]{width:610px;max-height:240px;font-size:16px;border:1px solid #ccc}.resident-group-list .list-body[data-v-24827c22]{overflow-y:scroll;overflow-x:auto}.resident-group-list .list-body .resident[data-v-24827c22]{padding:8px;border-bottom:1px solid #dcdcdc}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
